"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RedeemSectionLoggedIn_1 = __importDefault(require("./RedeemSectionLoggedIn"));
const react_1 = __importDefault(require("react"));
const RedeemSectionUnLoggedIn_1 = __importDefault(require("./RedeemSectionUnLoggedIn"));
const RedeemSectionVerifiedCode_1 = __importDefault(require("./RedeemSectionVerifiedCode"));
const RedeemSection = ({ posaRedeemStore, accountName, landingPageViewed, isLoggedIn, uppercaseCode, data, getStartAction, loginModal, prefilledCode }) => {
    const { code, codeVerified } = posaRedeemStore;
    if (code && codeVerified)
        return react_1.default.createElement(RedeemSectionVerifiedCode_1.default, { data: data, posaRedeemStore: posaRedeemStore, accountName: accountName });
    if (landingPageViewed && isLoggedIn && !codeVerified) {
        return (react_1.default.createElement(RedeemSectionLoggedIn_1.default, { posaRedeemStore: posaRedeemStore, uppercaseCode: uppercaseCode, data: data, prefilledCode: prefilledCode, accountName: accountName }));
    }
    return react_1.default.createElement(RedeemSectionUnLoggedIn_1.default, { data: data, getStartAction: getStartAction, loginModal: loginModal });
};
exports.default = RedeemSection;
//# sourceMappingURL=RedeemSection.js.map